import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, Input, Label } from 'reactstrap';
import { Separator } from '../../../../../../components/common/CustomBootstrap';
export default function SecuritySettings({
  securitySettings,
  saveIntegration,
}) {
  const [dailyCallLimit, setDailyCallLimit] = useState(
    securitySettings?.dailyCallLimit !== undefined
      ? securitySettings?.dailyCallLimit
      : 100000
  );
  const [concurrentCallLimit, setConcurrentCallLimit] = useState(
    securitySettings?.concurrentCallLimit !== undefined
      ? securitySettings?.concurrentCallLimit
      : -1
  );

  useEffect(() => {
    setDailyCallLimit(
      securitySettings?.dailyCallLimit !== undefined
        ? securitySettings?.dailyCallLimit
        : 1
    );
    setConcurrentCallLimit(
      securitySettings?.concurrentCallLimit !== undefined
        ? securitySettings?.concurrentCallLimit
        : -1
    );
  }, [securitySettings]);

  const handleDailyCallLimitChange = (e) => {
    const value = e.target.value;
    setDailyCallLimit(value);
  };

  const handleConcurrentCallLimitChange = (e) => {
    const value = e.target.value;
    setConcurrentCallLimit(value);
  };

  const handleSave = () => {
    let security = {
      dailyCallLimit: dailyCallLimit,
      concurrentCallLimit: concurrentCallLimit,
    };
    saveIntegration({ security: security });
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <h5>Keep your Voice AI Secure</h5>
        <Separator className="my-4" />
        <div className="mt-4">
          <Label>
            <b>Daily call limit</b>
          </Label>
          <p className="my-1">The maximum number of calls allowed per day.</p>
          <div className="d-flex">
            <Input
              type="number"
              name="dailyCallLimit"
              className="form-control"
              value={dailyCallLimit}
              style={{ width: '70%' }}
              onChange={handleDailyCallLimitChange}
              min={-1}
            />
            <span className="ml-2 mt-2">Calls per day</span>
          </div>
        </div>
        <div className="mt-4">
          <Label>
            <b>Concurrent call limit</b>
          </Label>
          <p className="my-1">
            The maximum number of concurrent calls allowed.
          </p>
          <div className="d-flex">
            <Input
              type="number"
              name="concurrentCallLimit"
              className="form-control"
              style={{ width: '70%' }}
              value={concurrentCallLimit}
              onChange={handleConcurrentCallLimitChange}
              min={-1}
            />
            <span className="ml-2">Using subscription limit</span>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4">
          <Button size="xs" onClick={handleSave} outline color="primary">
            Save
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}
